module.exports = fox._r("images/bg/btn_pink.gif", __webpack_public_path__ + "images/bg/btn_pink.gif");


//////////////////
// WEBPACK FOOTER
// ./images/bg/btn_pink.gif
// module id = 1009
// module chunks = 4